import { FAILED, LOADING, SUCCESS } from './constants';
import {
  summaryTransaction,
  chartReport,
  listProducts,
  bestSelling,
  summaryTransactionDetails,
} from '../../utils/api';

export const fetchSummary = (startDate = '', endDate = '') => {
  return async (dispatch) => {
    const key = 'Summary';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await summaryTransaction(startDate, endDate);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchSummaryDetail = (
  categoryKey = '',
  startDate = '',
  endDate = ''
) => {
  return async (dispatch, getState) => {
    const key = 'SummaryDetails';
    dispatch(loadingAction(true, key));
    try {
      const category = getState().pageBase?.dataProductCategories?.find(
        (c) => c.name.toLowerCase().trim() === categoryKey
      );
      const { data } = await summaryTransactionDetails(
        startDate,
        endDate,
        category?.categoryId,
      );
      dispatch(successAction(data ?? [], key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchBestSelling = (startDate = '', endDate = '') => {
  return async (dispatch) => {
    const key = 'BestSelling';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await bestSelling(startDate, endDate);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchReport = (
  provinceId = '',
  categoryId = '',
  productId = ''
) => {
  return async (dispatch) => {
    const key = 'ChartReport';
    dispatch(loadingAction(true, key));
    if (!categoryId) {
      return dispatch(successAction([], key));
    }
    const { data } = await chartReport({ provinceId, categoryId, productId });
    const chartData = {
      cities: [],
      data: [],
    };
    data.forEach((dt) => {
      let cityName = '';
      const arrayNames = dt?.city?.split(' ');
      if (arrayNames.length > 2) {
        cityName = [
          arrayNames.slice(0, 2).join(' '),
          arrayNames.slice(2).join(' '),
        ];
      } else {
        cityName = [dt?.city];
      }
      chartData.cities.push(cityName);
      chartData.data.push(dt.total);
    });
    dispatch(successAction(chartData, key));
  };
};

export const fetchProducts = (categoryId) => {
  return async (dispatch) => {
    const key = 'Products';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await listProducts(categoryId);
      const products = data.map((p) => ({
        value: p.productId,
        name: p.productName,
      }));
      dispatch(successAction(products, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}
